export default "__VITE_ASSET__DiHEfyUP__"